module.exports = __webpack_public_path__ + "static/media/r2-4.d34117ac.jpg";